




































































import {Component, Prop, Vue} from 'vue-property-decorator';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import {IMenuItem, MenuStore} from '@/store/modules/menu.store';
import {CartStore} from '@/store/modules/cart.store';
import {LocationStore} from '@/store/modules/location.store';
import ViewCart from '@/components/ViewCart.vue';
// @ is an alias to /src

@Component({
	components: {
		typeahead: VueBootstrapTypeahead,
		'view-cart': ViewCart
	}
})
export default class ItemMenu extends Vue {
	@Prop({required: true})
	ticketId!: string;

	@Prop({required: true})
	menuId!: string;

	search = '';

	showItemOptions = false;
	showViewCart = false;

	selectedItemId = '';

	get menuName() {
		const menu = MenuStore.menu(this.menuId);
		return menu ? menu.name : '';
	}

	itemsForCategory(category: string) {
		return MenuStore.itemsForCategoryByMenu(this.menuId, category);
		// return this.items.filter((item) => {
		// 	return item.category === category;
		// });
	}

	get categories() {
		return MenuStore.categoriesByMenu(this.menuId);
	}

	get items() {
		return MenuStore.itemsByMenu(this.menuId);
	}

	get cartSize() {
		return CartStore.itemsByTicket(this.ticketId).reduce((total, item) => {
			total += item.quantity;
			return total;
		}, 0);
	}

	get locationName() {
		if(LocationStore.location) {
			return LocationStore.location.name;
		}
		return '';
	}

	openItemOptions(item: IMenuItem) {
		this.selectedItemId = item.itemId;
		this.showItemOptions = true;
	}

	serializeItem(input: {name: string}) {
		return input.name;
	}

	close() {
		this.$emit('close');
	}

	machineName(name: string) {
		return name.replace(/ /g, '-').replace(/[^A-Za-z\-]/g, '').toLowerCase();
	}

	scrollToCategory(categoryName: string) {
		this.$nextTick(() => {
			(this.$refs[categoryName] as any)[0].scrollIntoView();
		});
	}

	viewCart() {
		this.showViewCart = true;
	}

	closeAll() {
		this.showViewCart = false;
		this.close();
	}

}
